// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"430ffee2","225":"ebb13f41","292":"36485321","855":"3d53db21"}[chunkId] + ".chunk.css";
};